import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/button';
import { cn } from '@/utils/cn';
import type { MenuItemGroup } from '@/utils/navigation.utils';
import { isNavItemOrGroupActive } from '@/utils/navigation.utils';
import { SubMenuItem } from './SubMenuItem';

const getVariant = (opened: boolean, isActive: boolean) => {
  if (opened) {
    return 'secondary';
  }

  return isActive ? 'primary' : 'ghost';
};

type NavigationItemGroupProps = {
  item: MenuItemGroup;
};

export const NavigationItemGroup = ({ item }: NavigationItemGroupProps) => {
  const pathname = usePathname();
  const isActive = isNavItemOrGroupActive({
    currentPath: pathname,
    item,
  });

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <PopoverButton
            aria-expanded={open}
            aria-haspopup={true}
            as={Button}
            className={cn(
              'mx-2 flex items-center',
              item.id === 'pickems' && isActive && 'text-white',
              item.id === 'pickems' && !isActive && 'text-light-blue'
            )}
            glow={item.id === 'pickems' && isActive}
            variant={getVariant(open, isActive)}
          >
            {item.icon && <span className="shrink-0">{item.icon}</span>}
            <span>{item.name}</span>
            <ChevronDownIcon
              aria-hidden="true"
              className={cn(
                'h-4 w-4 transition-transform',
                open ? 'rotate-180 transform' : ''
              )}
            />
          </PopoverButton>
          <PopoverPanel className="absolute z-10 mt-2 w-56">
            <div className="rounded-lg bg-dark-gray text-sm shadow-lg ring-1 ring-gray-900/5">
              <div className="p-4">
                {item.subLinks.map((subItem) => (
                  <SubMenuItem close={close} item={subItem} key={subItem.id} />
                ))}
              </div>
            </div>
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
};
